import { useNavigate } from 'react-router-dom';
import WellnessOnboarding from '@/components/onboarding/WellnessOnboarding';
import { HOME_PATH } from '@/lib/paths';

export default function WellnessTracks() {
  const navigate = useNavigate();

  const handleComplete = () => {
    navigate(HOME_PATH);
  };

  return <WellnessOnboarding onComplete={handleComplete} />;
}
